enum ReportModalState {
  HIDDEN,
  PICK_CUSTOMER_ANDOR_TYPE,
  DOWNLOADING,
  DONE,
  ERROR,
}

export default ReportModalState;
